import React from "react";
import { Link } from "react-router-dom";

const NewDrawr = ({ open, setOpen }) => {
  const drawerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "250px",
    height: "100vh",
    backgroundColor: "#111",
    color: "#fff",
    paddingTop: "60px", // <-- yahan top se spacing di
    paddingLeft: "20px",
    paddingRight: "20px",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease",
    transform: open ? "translateX(0)" : "translateX(-100%)",
    zIndex: 1001,
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    transition: "opacity 0.3s ease",
    opacity: open ? 1 : 0,
    pointerEvents: open ? "auto" : "none",
    zIndex: 1000,
  };

  const linkStyle = {
    color: "#ffd700",
    margin: "10px 0",
    fontWeight: "bold",
    textDecoration: "none",
  };

  return (
    <>
      <div style={overlayStyle} onClick={() => setOpen(false)}></div>

      <div style={drawerStyle}>
  <button
    onClick={() => setOpen(false)}
    style={{
      position: "absolute",
      top: "15px",
      right: "15px",
      background: "none",
      border: "none",
      color: "red",
      fontSize: "28px",
      cursor: "pointer",
    }}
  >
    ✖
  </button>

  <Link to="/" style={linkStyle} onClick={() => setOpen(false)}>
    Home
  </Link>

  <Link to="/myCources" style={linkStyle} onClick={() => setOpen(false)}>
    My Course
  </Link>
</div>
    </>
  );
};

export default NewDrawr;